import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'callvibe-web-app'
    }
  }
})

// Auth helper functions
export const getCurrentUser = () => {
  return supabase.auth.getUser()
}

export const getCurrentSession = () => {
  return supabase.auth.getSession()
}

export const signUp = async (email, password) => {
  return await supabase.auth.signUp({
    email,
    password,
  })
}

export const signIn = async (email, password) => {
  return await supabase.auth.signInWithPassword({
    email,
    password,
  })
}

export const signOut = async () => {
  return await supabase.auth.signOut({ scope: 'local' })
}

export const onAuthStateChange = (callback) => {
  return supabase.auth.onAuthStateChange(callback)
}

export const resetPasswordForEmail = async (email, redirectPath = '/update-password') => {
  const redirectTo = typeof window !== 'undefined' ? `${window.location.origin}${redirectPath}` : undefined
  return await supabase.auth.resetPasswordForEmail(email, { redirectTo })
}

export const updatePassword = async (newPassword) => {
  return await supabase.auth.updateUser({ password: newPassword })
}
